module.exports = __webpack_public_path__ + "img/placeList3.228a6b8e.png";